import { SetStorage, GetStorage, EnumStorageKeys } from '@/data/protocols/cache'
export class LocalStorageAdapter implements SetStorage, GetStorage {
  readonly KEYS = EnumStorageKeys

  set(key: EnumStorageKeys, value?: object | string): void {
    if (value) {
      localStorage.setItem(key, JSON.stringify(value))
    } else {
      localStorage.removeItem(key)
    }
  }

  get(key: EnumStorageKeys): string | null {
    const data = localStorage.getItem(key)
    return data ? JSON.parse(data) : null
  }
}
